import {useThemeChange} from './use-theme-change.js';
export default useThemeChange;
